import React from "react";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import Wave from "react-wavify";

const guidelinesData = {
  "guidelines": [
    {
      "category": "USER GUIDELINES FOR PIPELINE DAMAGE",
      "steps": [
        "Ensure Personal Safety: Prioritize safety for yourself and others.",
        "Report the Incident to Jal-Suraksha: Report pipeline damage to Jal-Suraksha.",
        "Warn Others: If safe, warn nearby residents about the damage.",
        "Evacuate if Necessary: Follow evacuation instructions if there is an immediate threat.",
        "Do Not Attempt Repairs: Avoid attempting to repair the pipeline unless trained.",
        "Document the Scene: Document the scene with photographs or videos.",
        "Avoid Ignition Sources: Keep a safe distance and avoid ignition sources.",
        "Protect Yourself from Exposure: Avoid direct contact with leaking substances.",
        "Follow Official Instructions: Adhere to instructions from local authorities.",
        "Provide Information to Authorities: Provide statements and information to authorities.",
        "Support Cleanup Efforts: Participate in or support cleanup efforts.",
        "Advocate for Preventive Measures: Engage with local authorities for preventive measures.",
        "Stay Informed about Health Risks: Stay informed about health risks associated with the damage.",
        "Promote Environmental Awareness: Use the incident to promote environmental awareness.",
        "Monitor Water Quality: Stay vigilant about water quality in your locality."
      ]
    }
  ]
};

const FixedBottomAnimation = () => (
  <div className="absolute bottom-0 left-0 right-0">
    <Wave
      mask="url(#mask)"
      fill="#49B5F0"
      options={{
        height: 10,
        amplitude: 24,
        speed: 0.3,
        points: 3,
      }}
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0" stopColor="white" />
          <stop offset="0.5" stopColor="black" />
        </linearGradient>
      </defs>
    </Wave>
  </div>
);

const DamagePipeline = () => {
  return (
    <div className="relative bg-white overflow-y-auto pb-20">
      <div className="w-full text-center">
        <div className="mb-2 mx-auto md:w-[7.5%] md:h-[7.5%] w-[15%] h-[15%] mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
            alt=""
          />
        </div>
        <div className="mb-2 mx-auto md:w-[2%] w-[4%] mt-0">
          <img
            src={Logo}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="mb-2 mx-auto md:w-[10%] w-[20%] mt-2">
          <img
            src={logotxt}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="p-6 bg-white text-black rounded border border-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-center border-b border-black pt-2">{guidelinesData.guidelines[0].category}</h1>
          <div className="text-left text-xl">
            <ul className="list-disc list-inside">
              {guidelinesData.guidelines[0].steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
          <div className="p-10"></div>
        </div>
      </div>
      <FixedBottomAnimation />
    </div>
  );
};

export default DamagePipeline;
